import { registerLocale, setDefaultLocale } from "react-datepicker";

export const addLocale = (key, value) => {
  registerLocale(key, value);
};

export const setLocale = (key) => {
  setDefaultLocale(key);
};
